<section>
  <div class='v-header'>
    <h1>{{"pages.user-vehicle.myVehicles" | translate}}</h1>
    <button *ngIf="!this.nowLoading && userService._organisation !=='UDES' " class='bciti-button bciti-button--blue' (click)='openCreate()'>{{"pages.user-vehicle.addVehicle" | translate}}</button>
  </div>

  <app-vehicle-list [vehicles]='vehicleslist'></app-vehicle-list>


</section>